import { ApiService } from "@core/api/api-service";
import { OnfidoInitConfig } from "@domain/onfido/onfido";

export class OnfidoService {
	constructor(private readonly authenticatedApiService: ApiService) {}

	async getOnfidoInitConfig(): Promise<OnfidoInitConfig> {
		const result = await this.authenticatedApiService.get<OnfidoInitConfig>("/onfido");
		return result.data;
	}
}
